import { ScaleFade, Img } from '@chakra-ui/react';
import React from 'react'
import Loader from './../Loader/Loader';

export const ImageViewer = ({ file, loading, setLoading }) => {
    return <>
        <Loader loading={loading} />
        <ScaleFade initialScale={0.9} in >
            <Img
                onLoad={() => setLoading(false)}
                borderRadius="0.25em"
                position="relative"
                src={file.url ? file.url : URL.createObjectURL(file)}
                zIndex="0"
                objectFit="cover" />
        </ScaleFade>
    </>
}